import { ChevronLeftIcon, ChevronRightIcon, cn } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { PropsWithChildren } from 'react';
import { useTranslationsContext } from '../../../../../../Translations/UseTranslationsContext';
import CarouselStore from '../CarouselStore';
import { getNavigationButtonStatus, visibilityNavigationButton } from './Functions';
import NavigationButton from './NavigationButton';
import NavigationDots from './NavigationDots';
import { CarouselDotProps } from './Types';

interface Props<T> {
  className?: string;
  carouselStore: CarouselStore<T>;
  dotProps?: CarouselDotProps;
}

function CarouselWithButtons<T>({
  className,
  carouselStore,
  children,
  dotProps = {},
}: PropsWithChildren<Props<T>>) {
  const { translate } = useTranslationsContext();

  const visibility = visibilityNavigationButton(
    carouselStore.perPageCount,
    carouselStore.totalCount,
  );

  return (
    <div className={cn('relative flex flex-col overflow-visible', className)}>
      <div className="flex w-full xl:-mx-16">
        <NavigationButton
          aria-label={translate('Previous page')}
          icon={ChevronLeftIcon}
          visibility={visibility}
          disabled={getNavigationButtonStatus(carouselStore.precedingPages)}
          onClick={carouselStore.retreat}
        />
        <div className="relative w-full">{children}</div>
        <NavigationButton
          aria-label={translate('Next page')}
          icon={ChevronRightIcon}
          visibility={visibility}
          disabled={getNavigationButtonStatus(carouselStore.succeedingPages)}
          onClick={carouselStore.advance}
        />
      </div>
      <NavigationDots
        className={dotProps.className}
        dots={carouselStore.navDots}
        onDotClick={carouselStore.gotoPage}
      />
    </div>
  );
}

export default observer(CarouselWithButtons);
